/*
 * Landeswährung an JEDEM Preis. (Lukas, 02.09.2026)
 *
 * Reihenfolge auf Lukas' ausdrückliche Entscheidung: Die LANDESWÄHRUNG führt in
 * der Größe, die der Euro-Preis an dieser Stelle hatte; der Euro-Betrag steht
 * klein darunter. Auf der Produktseite und in der Warenkorbsumme kommt der
 * Zusatz "abgerechnet wird in Euro" dazu, auf Kacheln nicht — dort wäre er Lärm.
 * Ich hatte auf die PAngV hingewiesen (genannter Gesamtpreis ist der Euro-Betrag,
 * und der rutscht damit ins Kleingedruckte, während oben eine aufgerundete
 * Schätzung steht). Lukas hat die Fassung nach dem Hinweis bestätigt.
 *
 * Die Preise werden GESUCHT, nicht in den Vorlagen markiert: Preise stehen in
 * Karussells, Kacheln, Schnellbestellern, Suchergebnissen und im Warenkorb, und
 * die Hälfte davon wird nachgeladen. Ein Einhängen je Vorlage hätte die Hälfte
 * verfehlt und bei jeder Theme-Änderung neu verfehlt.
 */
(function () {
  'use strict';
  if (window.__rhWaehrung) return;
  window.__rhWaehrung = true;

  /* Wer die Sprache SELBST umstellt, hat damit auch sein Land gesagt: Tschechisch
     heisst Kronen, egal von wo der Abruf kommt. Die Sprache schlaegt die Ortung. */
  var SPRACHE_WAEHRUNG = { cs: 'CZK', da: 'DKK', sv: 'SEK', pl: 'PLN', hu: 'HUF', ro: 'RON' };

  /* Bleibt die Sprache eine Euro-Sprache (deutsch, englisch, finnisch …), entscheidet
     das erkannte Land — ein Schweizer auf der deutschen Fassung sieht Franken. */
  var LAND_WAEHRUNG = {
    dk: 'DKK', se: 'SEK', no: 'NOK', pl: 'PLN', cz: 'CZK',
    hu: 'HUF', ro: 'RON', gb: 'GBP', ch: 'CHF'
  };

  /* Aufrundungsschritt je Währung: grob genug, dass Kursschwankungen die
     angezeigte Zahl nicht täglich verändern, fein genug zum Einordnen. */
  var SCHRITT = { DKK: 5, SEK: 5, NOK: 5, PLN: 5, CZK: 10, HUF: 100, RON: 5, GBP: 1, CHF: 1 };

  /* Schreibweise je Währung: Zeichen, Seite, Tausendertrennung. */
  var FORM = {
    DKK: { z: 'kr', hinten: true, tr: '.' }, SEK: { z: 'kr', hinten: true, tr: ' ' },
    NOK: { z: 'kr', hinten: true, tr: ' ' }, PLN: { z: 'zł', hinten: true, tr: ' ' },
    CZK: { z: 'Kč', hinten: true, tr: ' ' }, HUF: { z: 'Ft', hinten: true, tr: ' ' },
    RON: { z: 'lei', hinten: true, tr: '.' }, GBP: { z: '£', hinten: false, tr: ',' },
    CHF: { z: 'CHF', hinten: false, tr: '’' }
  };

  /* Zusatz am Euro-Betrag, in allen fünfzehn Sprachen. Englisch ist der Rückfall. */
  var ZUSATZ = {
    de: 'abgerechnet wird in Euro', en: 'billed in euros', fr: 'facturé en euros',
    it: 'addebito in euro', es: 'se cobra en euros', nl: 'afrekening in euro',
    pl: 'rozliczenie w euro', sv: 'debiteras i euro', cs: 'účtováno v eurech',
    da: 'afregnes i euro', fi: 'veloitetaan euroina', hu: 'az elszámolás euróban történik',
    ro: 'se facturează în euro', el: 'η χρέωση γίνεται σε ευρώ', pt: 'cobrado em euros'
  };

  var daten = (function () {
    var el = document.querySelector('[data-rh-wg-daten]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  })();
  if (!daten || !daten.kurse) return;

  var sprache = String(daten.sprache || 'de').toLowerCase().split('-')[0];
  var zusatzText = ZUSATZ[sprache] || ZUSATZ.en;

  /* ---------- Land ermitteln ---------- */
  function land(dann) {
    var gemerkt = null;
    try { gemerkt = sessionStorage.getItem('rh-land'); } catch (e) { /* privater Modus */ }
    if (gemerkt) return dann(gemerkt);
    fetch('/browsing_context_suggestions.json?source=geolocation_recommendation&show_all_countries=false',
          { headers: { accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var l = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!l) return;
        l = String(l).toLowerCase();
        try { sessionStorage.setItem('rh-land', l); } catch (e) { /* egal */ }
        dann(l);
      })
      .catch(function () { /* ohne Land eben keine Zweitwährung */ });
  }

  /* ---------- Rechnen und Schreiben ---------- */
  /* "149,90 €", "€149.90", "1.234,50 €" — die letzte Trennung mit ein oder zwei
     Nachkommastellen ist das Komma, alles davor sind Tausender. */
  function euroAus(text) {
    var roh = String(text).replace(/[^\d.,]/g, '');
    if (!roh) return null;
    var m = roh.match(/^(.*?)([.,](\d{1,2}))?$/);
    var ganz, rest;
    if (m && m[2] && !/[.,]\d{3}$/.test(roh)) { ganz = m[1]; rest = m[3]; }
    else { ganz = roh; rest = ''; }
    ganz = ganz.replace(/[.,]/g, '');
    if (!ganz) return null;
    var wert = parseFloat(ganz + '.' + (rest || '0'));
    return isFinite(wert) && wert > 0 ? wert : null;
  }

  function formatiere(betrag, waehrung) {
    var f = FORM[waehrung] || { z: waehrung, hinten: true, tr: ' ' };
    var s = String(Math.round(betrag)).replace(/\B(?=(\d{3})+(?!\d))/g, f.tr);
    return f.hinten ? s + ' ' + f.z : f.z + ' ' + s;
  }

  function umrechnen(euro, waehrung) {
    var kurs = daten.kurse[waehrung];
    if (!kurs) return null;
    var schritt = SCHRITT[waehrung] || 1;
    return Math.ceil((euro * kurs) / schritt) * schritt;   /* immer nach oben */
  }

  /* Welche Preise zählen: der geltende Preis, nicht der durchgestrichene, nicht
     der Grundpreis und nicht die versteckte Warenkorbsumme im Kopf. */
  function preise() {
    return Array.prototype.filter.call(
      document.querySelectorAll('hdt-price .hdt-money, .hdt-totals__total-value'),
      function (n) {
        if (n.dataset.rhWg) return false;
        if (!String(n.textContent).replace(/\s/g, '')) return false;
        if (n.closest('hdt-compare-at-price, hdt-unit-price, .hdt-compare-at-price, .hdt-unit-price, .hdt-hidden, [hidden], .sr-only')) return false;
        return true;
      });
  }

  /* Der Zusatz "abgerechnet wird in Euro" nur dort, wo er nicht stört:
     Hauptpreis der Produktseite und Warenkorbsumme. */
  function mitZusatz(preis) {
    return !!preis.closest('.hdt-product__price, .hdt-totals');
  }

  function behandeln(preis, waehrung) {
    var euro = euroAus(preis.textContent);
    if (euro == null) return;
    var betrag = umrechnen(euro, waehrung);
    if (betrag == null) return;

    /* Der Kasten, der den Euro-Betrag zeigt — davor kommt der grosse Betrag.
       Bei reduzierten Artikeln ist das die GANZE Preiszeile: sonst stuende der
       Landesbetrag zwischen dem durchgestrichenen und dem gueltigen Preis. */
    var kasten = preis.closest('.hdt-price__list, .hdt-price__sale')
      || preis.closest('hdt-price') || preis;
    var eltern = kasten.parentNode;
    if (!eltern) return;

    var gross = kasten.previousElementSibling;
    if (!gross || !gross.classList || !gross.classList.contains('rh-wg')) {
      gross = document.createElement('span');
      gross.className = 'rh-wg';
      /* Die Grösse des Euro-Betrags AN DIESER STELLE übernehmen: auf der
         Produktseite 20px, auf Kacheln kleiner. Vor dem Schrumpfen lesen. */
      gross.style.fontSize = window.getComputedStyle(preis).fontSize;
      eltern.insertBefore(gross, kasten);
    }
    gross.textContent = formatiere(betrag, waehrung);

    kasten.classList.add('rh-wg-klein');
    preis.dataset.rhWg = '1';

    if (mitZusatz(preis)) {
      /* Im Warenkorb haengt der Zusatz an den PAngV-Hinweis, sonst stuende
         "· abgerechnet wird in Euro" allein auf einer Zeile. */
      var behaelter = preis.parentNode || kasten;
      var summe = preis.closest('.hdt-cart-totals-discounts');
      if (summe) {
        var hinweis = summe.querySelector('.rh-preishinweis');
        if (hinweis) behaelter = hinweis;
      }
      var zusatz = behaelter.querySelector('.rh-wg__zusatz');
      if (!zusatz) {
        zusatz = document.createElement('span');
        zusatz.className = 'rh-wg__zusatz';
        behaelter.appendChild(zusatz);
      }
      zusatz.textContent = ' · ' + zusatzText;
    }

    /* Variantenwechsel und Rabatte schreiben den Betrag neu — dann wir auch. */
    if (!preis.__rhBeobachtet) {
      preis.__rhBeobachtet = true;
      new MutationObserver(function () {
        var neu = euroAus(preis.textContent);
        if (neu == null) return;
        var b = umrechnen(neu, waehrung);
        if (b != null) gross.textContent = formatiere(b, waehrung);
      }).observe(preis, { childList: true, characterData: true, subtree: true });
    }
  }

  function durchlauf(waehrung) {
    preise().forEach(function (p) { behandeln(p, waehrung); });
  }

  function starten(waehrung) {
    if (!waehrung || !daten.kurse[waehrung]) return;   /* Euro: nichts zu tun */
    durchlauf(waehrung);
    /* Karussells, Schnellansicht und Warenkorb laden nach. */
    var wartet = false;
    new MutationObserver(function () {
      if (wartet) return;
      wartet = true;
      requestAnimationFrame(function () { wartet = false; durchlauf(waehrung); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  var ausSprache = SPRACHE_WAEHRUNG[sprache];
  if (ausSprache) starten(ausSprache);
  else land(function (l) { starten(LAND_WAEHRUNG[l]); });
})();
